import { connect } from 'react-redux';
import { IStoreState, IStateCollection } from 'src/entity/StateEntity';
import VASOrderAddForm from 'src/components/common/VASOrderAddForm';
import { Dispatch } from 'react';

const mapStateToProps = ({ selectDoctorState: { doctorInfo }, userState: { isDomestic }, rechargeState: { options } }: IStoreState) => ({
  doctorInfo,
  isDomestic,
  rechargeList: options,
});

const mapDispatchToProps = (dispatch: Dispatch<IStateCollection>) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VASOrderAddForm);



// WEBPACK FOOTER //
// ./src/containers/VASOrderAdd.ts